module.exports = __webpack_public_path__ + "static/media/hero-image.68718083.png";